
<div style="display: block" class="pl-2 doc-col" >
    <div class="doc-info v-flex">
        <!-- unit chip -->
        <div v-if="document.unitName" class="doc-unit mr-1 primary white--text">
            <div style="margin-top: -2px">
                {{ document.unitName }}
            </div>
        </div>
        <!-- unit chip -->

        <!-- bid chip -->
        <div v-if="document.bidId" class=" mr-1">
            {{ bidname }}
        </div>
        <!-- bid chip -->

        <!-- document type -->
        <div class=" mr-1">
            {{ document.type ? document.type.name : '---'}}
        </div>
        <!-- document type -->

        <v-spacer />
    </div>

    <div class="doc-subinfo doc-filename">
        {{ document.name }}
    </div>
</div>
